export enum TagVariant {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary',
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  Linolium = 'linolium',
  Eggplant = 'eggplant',
}

export enum TagSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
}

export interface ITag extends React.HTMLAttributes<HTMLSpanElement> {
  /**
   * The value or text to display within the tag.
   */
  value?: string;

  /**
   * The child elements or nodes to render inside the tag.
   */
  children?: React.ReactNode;

  /**
   * Optional custom CSS class for the tag.
   */
  className?: string;

  /**
   * Variant of the tag, defining its appearance (e.g., primary, success, warning).
   */
  variant?: TagVariant;

  /**
   * Size of the tag (e.g., small, medium, large).
   */
  size?: TagSize;

  /**
   * Whether the tag should have rounded edges.
   */
  rounded?: boolean;
}
